import { ActionIcon, Button, Group, ScrollArea, UnstyledButton } from '@mantine/core'
import {
  IconArrowLeft,
  IconArrowRight,
  IconCopy,
  IconPlus,
  IconTrash,
} from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { getAtPath } from '../../utils/configPaths'
import classes from '../../styles/StudioEditorV2.module.css'

export function CollectionList({ collection, items, selected, onSelect, onAdd, onRemove, onMove, onDuplicate }) {
  const { t } = useTranslation()
  const label = collection.itemLabel || t('editorV2.form.collections.item')
  return (
    <Group gap="xs" wrap="nowrap" align="center">
      <ScrollArea type="auto" style={{ flex: '0 1 auto', minWidth: 0 }}>
        {/* Shares the joined pill group with SlideList so schema-v2 collections and
            schema-v1 slides look identical. */}
        <div className={classes.slideTabs}>
          {items.map((item, index) => (
            <UnstyledButton
              key={getAtPath(item, collection.identityPath) || index}
              className={index === selected ? classes.slideTabActive : classes.slideTab}
              onClick={() => onSelect(index)}
            >
              {collection.itemLabelPath && getAtPath(item, collection.itemLabelPath)
                ? getAtPath(item, collection.itemLabelPath)
                : `${label} ${index + 1}`}
            </UnstyledButton>
          ))}
        </div>
      </ScrollArea>
      {collection.reorderable && (
        <>
          <ActionIcon variant="subtle" color="gray" disabled={selected <= 0} aria-label={t('editorV2.form.collections.moveLeft', { label })} onClick={() => onMove(selected, -1)}>
            <IconArrowLeft size={16} />
          </ActionIcon>
          <ActionIcon variant="subtle" color="gray" disabled={selected >= items.length - 1} aria-label={t('editorV2.form.collections.moveRight', { label })} onClick={() => onMove(selected, 1)}>
            <IconArrowRight size={16} />
          </ActionIcon>
        </>
      )}
      {collection.duplicable && (
        <ActionIcon variant="subtle" color="gray" disabled={!items.length || items.length >= collection.maxItems} aria-label={t('editorV2.form.collections.duplicate', { label })} onClick={() => onDuplicate(selected)}>
          <IconCopy size={16} />
        </ActionIcon>
      )}
      {collection.removable && (
        <ActionIcon variant="subtle" color="red" disabled={items.length <= collection.minItems} aria-label={t('editorV2.form.collections.delete', { label })} onClick={() => onRemove(selected)}>
          <IconTrash size={16} />
        </ActionIcon>
      )}
      {collection.addable && (
        <Button size="compact-xs" variant="light" leftSection={<IconPlus size={14} />} disabled={items.length >= collection.maxItems} onClick={onAdd}>
          {t('editorV2.form.collections.add')}
        </Button>
      )}
    </Group>
  )
}
/* Stable-identity collection list for Schema V2 templates. */
